import smoothscroll from 'smoothscroll-polyfill';

// polyfill for "smooth" scroll behavior in IE 11 and Safari
if (typeof window !== 'undefined') {
  smoothscroll.polyfill();
}

/*!
 * @module scrollHelper
 * @param {node} target - valid query selector ex document.body
 * @param {object} - arguments listed below
 * @param {int} duration - length of the animation in ms
 * @param {str} easing - easing type: linear, ease-in, ease-out, ease-in-out
 * @param {int} offset - distance below the target the scroll will end
 *
 * @example
 * scrollHelper(window, {duration: 2000, easing: 'ease-in-out', offset: 300});
 *
 * @description
 * Takes a target element and calculates the scroll distance fromthe top of
 * the page, adds the optional offset, and passes it to scrollTo().
 * After scrolling is complete, focus is shifted to the target element.
 * For more information on scroll-js, see https://github.com/mkay581/scroll-js
 *
 * All parameters are optional - calling scrollHelper() with no parameters will
 * scroll to the top of the window with a duration of 1 second using ease-out.
 */

var scrollHelper = function scrollHelper() {
  var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.scrollingElement || document.documentElement;
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? 0 : _ref$offset;
  var scrollDistance = window.pageYOffset + target.getClientRects()[0].top + offset;
  window.setTimeout(function () {
    window.scrollTo({
      top: scrollDistance,
      behavior: 'smooth'
    });
  }, 100);
  window.setTimeout(function () {
    target.setAttribute('tabindex', '-1');
    target.focus();
  }, 500);
};
export default scrollHelper;